import { ComponentRef, inject, Injectable, Type, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ILoggerService, ILoggerServiceToken } from '../infrastructure/logger/logger-service.interface';


@Injectable({
  providedIn: 'root',
}) export class DialogBaseService {

  static rootViewContainer: ViewContainerRef;
  static logger: ILoggerService; // no injection in static
  static dialogIsOpenSubscription: Subject<boolean>;

  public constructor() {
    DialogBaseService.logger = inject(ILoggerServiceToken);
    DialogBaseService.dialogIsOpenSubscription = new Subject<boolean>();
  }

  static rootViewContainerRefSet(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  static dynamicComponentRemove(component: ComponentRef<any>) {
    component.destroy();
    this.dialogIsOpenSubscription.next(false);
  }

  static dialogGenericShow<DialogType>(componentType: Type<DialogType>, dialogOptions: (ref: ComponentRef<DialogType>) => void) {
    if (!this.rootViewContainer) {
      return;
    }

    let component = this.rootViewContainer.createComponent(componentType);

    dialogOptions(component);

    this.rootViewContainer.insert(component.hostView);
    this.dialogIsOpenSubscription.next(true);
  }

}
